import { InformationPayload } from "src/entity/information/information.entity";
import http from "../utils/http-common";

const baseInformaionPath = "/api/information";

export const getInformation = (params: { companyId: string | null; path: string }) => {
  return http.get(`${baseInformaionPath}`, { params });
};

export const createInformation = (data: InformationPayload[]) => {
  return http.post(`${baseInformaionPath}`, data);
};

export const updateInformation = (data: InformationPayload) => {
  return http.patch(`${baseInformaionPath}`, data);
};
